<template>
    <div>
        <v-app-bar color="primary" fixed tile class="bottom-bordered" flat app dense>
            <v-app-bar-nav-icon to="/">
                <v-icon large>mdi-chevron-left</v-icon>
            </v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            <v-menu left bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                        <v-icon>mdi-share-variant</v-icon>
                    </v-btn>
                </template>
                <social-sharing :url="`https://arclif.com/post/${this.$route.params.postId}/`" inline-template>
                    <div class="v-list v-sheet v-sheet--tile theme--light">
                        <network network="facebook">
                            <div tabindex="0" role="menuitem" class="v-list-item v-list-item--link">
                                <div data-v-0cffa8b1="" class="v-list-item__title">
                                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-facebook mr-2"></i> Facebook
                                </div>
                            </div>
                        </network>
                        <network network="whatsapp">
                            <div tabindex="0" role="menuitem" class="v-list-item v-list-item--link">
                                <div data-v-0cffa8b1="" class="v-list-item__title">
                                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-whatsapp mr-2"></i> Whatsapp
                                </div>
                            </div>
                        </network>
                    </div>
                </social-sharing>
            </v-menu>
            <v-menu left bottom v-if="user.id === post.user_id">
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="showWarningDialog">
                        <v-list-item-icon class="mr-4">
                            <v-icon color="error">mdi-trash-can-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Delete Post</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <confirm-dialog v-if="user.id === post.user_id" v-model="dialog" @confirmDelete="deletePost">
            <template v-slot:title>Are you sure?</template>
        </confirm-dialog>
    </div>
</template>
<script>
import {
    DEL_POST
} from "@/store/actions.type"
export default {
    data: () => ({
        dialog: false
    }),

    methods: {
        showWarningDialog() {
            this.dialog = true
        },

        deletePost() {
            this.$store.dispatch(DEL_POST, this.$route.params.postId)
        }
    },

    computed: {
        post() {
            return this.$store.getters.getCurrentPost
        }
    }
}
</script>